<template>
  <v-card class="telemetry-card" elevation="8">
    <v-card-title :class="`card-header ${theme} white--text`">
      {{ title }}
    </v-card-title>
    <v-card-text class="pa-0 chart-content">
      <div class="chart-container">
        <slot></slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TelemetryCard',
  props: {
    title: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'success', 'warning', 'error'].includes(value)
    }
  }
}
</script>

<style scoped>
.telemetry-card {
  border-radius: 12px !important;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: auto;
}

.card-header {
  font-size: 1.4rem !important;
  font-weight: 700;
  padding: 12px 20px;
  height: 60px;
  flex-shrink: 0;
}

.chart-content {
  flex: 1;
  height: calc(100% - 60px);
  overflow: hidden;
}

.chart-container {
  width: 100%;
  height: 100%;
  padding: 8px;
}
</style>
